<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Crear contraseña Nueva
        .columns
          .column.is-offset-4.is-4
            .field
              label.label.is-size-5 Nueva Contraseña
              .control.has-icons-left.has-icons-right
                input.input.is-dark.is-medium(
                  type='password', 
                  placeholder='Contraseña Nueva',
                  v-model="password",
                  @keyup.enter="submitForm"
                )
                span.icon.is-small.is-left
                  i.fas.fa-key
              p.is-danger.help.is-size-5 {{ messageL1 }}
        .columns
          .column.is-offset-4.is-4
            .field
              label.label.is-size-5 Repetir Contraseña
              .control.has-icons-left.has-icons-right
                input.input.is-medium(
                  type='password', 
                  placeholder='Repetir Contraseña',
                  v-model="password_confirm",
                  @keyup.enter="submitForm"
                  :class="classInput"
                )
                span.icon.is-small.is-left
                  i.fas.fa-key
              p.id-danger.help.is-size-5 {{ messageL2 }} 
        .columns
          .column.is-4.is-offset-4
            div.has-text-centered
              button.button.is-primary.is-large.is-rounded(@click="saveForm()" :disabled="isDisabled") 
                | Guardar
        .columns(v-show="showNotificacion")
          .column.is-6.is-offset-3
            .notification
              button.delete(@click="hideNotification")
              p Reglas de contraseñas: Debe contener un número, una letra mayúscula, un símbolo, y mínimo 8 carácteres.
</template>

<script>
  import NavBar from "./layout/NavBar.vue"
  import Loader from "@/components/shared/Loader.vue"
  import usuariosServices from '@/services/usuarios/usuarios'
  import { mapState } from 'vuex'
  import moment from 'moment'

  export default {
    name: 'GeneradorPasswords',
    components: { Loader, NavBar },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin'])
    },
    data() {
      return {
        isLoading: false,
        messageL1: '',
        messageL2: '',
        isDisabled: true,
        password: '',
        password_confirm: '',
        isEqualsPass: false,
        classInput: 'is-dark',
        showNotificacion: true,
      }
    },
    watch: {
      password() {
        this.checkPasswords()
      },

      password_confirm() {
        this.checkPasswords()
      },
    },
    methods: {
      iniciarComponente() {
        setTimeout(() => {
          this.isLoading = false
        }, 3000)
      },
      checkPasswords() {
        if (this.password === '' || this.password_confirm === '') {
          this.isEqualsPass = false
          console.log(this.isEqualsPass)
          this.classInput = 'is-dark'
          return
        } else {
          if (this.password === this.password_confirm ) {
            console.log(this.isEqualsPass)
            this.messageL2 = ''
            this.isEqualsPass = true
            const isLong = this.password.length > 7
            console.log(isLong)
            const myRegExpMayus = /[A-Z]/
            const myRegSimbolos = /\W/
            const mayusTest = myRegExpMayus.test(this.password_confirm)
            const simbolTest = myRegSimbolos.test(this.password_confirm)
            
            if (!isLong || !mayusTest || !simbolTest) {
              this.isDisabled = true
              this.classInput = 'is-danger'
              this.messageL2 = `${isLong ? '' : 'La contraseña debe tener al menos 8 caracteres. '}
              ${mayusTest ? '' : 'La contraseña debe tener una letra MAYÚSCULA. '}${simbolTest ? '' : 'La contraseña debe tener al menos un símbolo.'}`
            } else {
              usuariosServices.checarPassExiste(this.userLogin.id, this.password_confirm)
                .then( data => {
                  const existe = parseInt(data[0].existe)
                  console.log(existe)
                  if (existe > 0) {
                    this.classInput = 'is-danger'
                    this.messageL2 = 'La Contraseña no debe ser una anterior.'
                    this.isDisabled = true
                  } else {
                    this.classInput = 'is-success'
                    this.messageL2 = 'Contraseña Válida'
                    this.hideNotification()
                    this.isDisabled = false
                  }
                })
                .catch( e => {
                  this.displayToast('bubble',e.message, 'ban', 'OK')      
                })
            }
            
          } else {
            this.isEqualsPass = false
            this.messageL2 = `Las contraseñas no coinciden`
            this.classInput = 'is-danger'
          }
        }
      },

      saveForm() {
        if (this.isDisabled) {
          return
        }
        const hoy = moment().format('YYYY-MM-DD')
        const _2meses = moment(hoy).add(2, 'months').format('YYYY-MM-DD')
        console.log(hoy)
        console.log(_2meses)
        usuariosServices.updatePassword(this.userLogin.id, this.password_confirm, _2meses)
          .then( data => {
            this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'OK')
            if (data.success) {
              this.$store.commit('usuarioLogueado', {})
              this.$router.push('/login')
            } 
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble',e.message, 'ban', 'OK')      
          })
      },
      
      hideNotification() {
        this.showNotificacion = false
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
    },
    computed: {
      ...mapState(['userLogin'])
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/passwords_Componentes/GeneradorPasswords.vue